<ui-wrapper>
  @if (navigation$ | async; as navigation) {
    @if (navigation.length > 0) {
      <!-- pod MOBILE_NAV_BREAKPOINT se navigace nevejde na jeden řádek – mobilní režim, tlačítko menu je v záhlaví -->
      <p-menubar class="app-nav-bar" [breakpoint]="mobileBreakpoint" [model]="navigation" />
    }
  }
</ui-wrapper>
